import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const BorderGrid = styled(Grid)`
  border: 1px solid;
  padding: 8px;
`;

export const GridLeft = styled(Grid)`
  border: 1px solid;
  padding: 8px;
`;

export const CheckBoxGrid = styled(Grid)`
  display: flex;
`;